"use strict";

exports.__esModule = true;
exports.default = removeValidation;

function removeValidation(profile, rules) {
  var allRules = [].concat(rules.personalFields, rules.businessFields);
  return allRules.reduce(function (acc, field) {
    var fieldValue = profile[field.name].value;

    if (field.submit && fieldValue != null) {
      acc[field.name] = field.submit(fieldValue);
    } else {
      acc[field.name] = fieldValue;
    }

    return acc;
  }, {});
}

module.exports = exports["default"];